import { ResultsSearchRow } from "app/pages/sales-intelligence/common-components/search-results-table";
import { useAppsSearchText } from "app/pages/sales-intelligence/modules/apps-search/hooks/useAppsSearchText";
import appsSearchI18nKeys from "app/pages/sales-intelligence/modules/apps-search/utils/i18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

const PLACEHODLER: Translatable = {
    key: appsSearchI18nKeys.searchTextPlaceholder,
};

type Props = {
    areTableActionsDisabled: boolean;
};

const AppsTableSearchRowContainer = ({ areTableActionsDisabled }: Props) => {
    const { searchText, onSearchTextChange, onSearchTextClear } = useAppsSearchText();

    return (
        <ResultsSearchRow
            searchText={searchText}
            placeholder={PLACEHODLER}
            isDisabled={areTableActionsDisabled}
            onSearch={onSearchTextChange}
            onSearchClear={onSearchTextClear}
        />
    );
};

export default AppsTableSearchRowContainer;
